module.exports = __webpack_public_path__ + "img/pad_icon_2.25d5c052.png";